import Hero from '../sections/hero';
import TrustStrip from '../sections/trust-strip';
import Services from '../sections/services';
import Equipment from '../sections/equipment';
import TrackRecord from '../sections/track-record';
import Reel from '../sections/reel';
import Contact from '../sections/contact';
import WhatsAppFloat from '../sections/whatsapp-float';

export default function Landing() {
    return (
        <>
            <Hero />
            <TrustStrip />
            <Services />
            <Equipment />
            <TrackRecord />
            <Reel />
            <Contact />
            <WhatsAppFloat />
        </>
    );
}
